/**
 * Contains utilities for saved states
 * @class SavedStates
 */

// Used to merge the categories list with the saved state.
export const restoreCategories = (categories, savedCategories) => {
  if (!savedCategories) {
    return categories;
  }
  return categories.map((cat) => {
    let savedCat = savedCategories.find((x) => x.id === cat.id);

    if (!savedCat) {
      return cat;
    }
    return {
      ...cat,
      categories: cat.categories.map((c) => {
        let savedC = savedCat.categories.find((x) => x.id === c.id);
        return {
          ...c,
          selected: savedC && savedC.selected ? savedC.selected : false,
        };
      }),
    };
  });
};



// WEBPACK FOOTER //
// ./app/util/savedStateUtils.js